import { render, staticRenderFns } from "./editUserConf.vue?vue&type=template&id=23140fdd"
import script from "./editUserConf.vue?vue&type=script&lang=js"
export * from "./editUserConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports